<template>
  <span class="badge" :class="[`badge--${tone}`, `badge--${size}`]">
    <i v-if="icon" :class="icon"></i>
    <slot />
  </span>
</template>

<script>
export default {
  name: 'BaseBadge',
  props: {
    tone: { type: String, default: 'brand' }, // brand | neutral | success | danger | warning | info | violet
    size: { type: String, default: 'md' },    // xs | sm | md
    icon: { type: String, default: '' }
  }
}
</script>

<style scoped>
.badge {
  display: inline-flex;
  align-items: center;
  gap: var(--space-2);
  border-radius: var(--radius-pill);
  font-weight: var(--font-weight-semibold);
  line-height: 1.2;
  white-space: nowrap;
  letter-spacing: 0.01em;
}

.badge i { font-size: 0.85em; }

/* Sizes */
.badge--xs { font-size: var(--text-2xs); padding: var(--space-0-5) var(--space-5); }
.badge--sm { font-size: var(--text-xs); padding: var(--space-1) var(--space-6); }
.badge--md { font-size: var(--text-sm); padding: var(--space-1) var(--space-8); }

/* Tones */
.badge--brand   { color: var(--color-brand-800); background: var(--primary-soft-2); }
.badge--neutral { color: var(--text-secondary); background: var(--bg-subtle); }
.badge--success { color: var(--success-text); background: var(--success-soft); }
.badge--danger  { color: var(--danger-text); background: var(--danger-soft); }
.badge--warning { color: var(--warning-text); background: var(--warning-soft); }
.badge--info    { color: var(--info); background: var(--info-soft); }
.badge--violet  { color: var(--violet-text); background: var(--violet-soft); }
</style>
